"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedBSCTestERC20 = void 0;
// List of the supported bsctest network tokens
exports.supportedBSCTestERC20 = {
    '0xEC5dCb5Dbf4B114C9d0F65BcCAb49EC54F6A0867': {
        name: 'DAI Token',
        symbol: 'DAI',
        decimals: 18,
    },
};
